<template>
  <v-btn
    text
    class="ml-auto"
    @click="clear_local_storage"
  >
    Колонки по умолчанию
  </v-btn>
</template>

<script lang="ts">
import {
  Vue, Prop, Component, PropSync,
} from 'vue-property-decorator';
import { TableCol } from '@/types';
import { global_store } from '@/store';

@Component
export default class ClearLocalStorage extends Vue {
  @Prop({ type: String, default: '', required: true })
  storage_name!: '';

  @Prop({ type: Array, default: () => ([]) })
  default_cols!: TableCol[];

  @PropSync('cols_list', { type: Array, default: () => ([]) })
  cols_list_local!: TableCol[]

  mounted() {
    this.clear_or_upd_cols();
  }

  optional_cols: TableCol[] | null = [];

  clear_local_storage() {
    const current_value = global_store.state.table_key;

    const incremented_value = current_value + 1;

    localStorage.removeItem(this.storage_name);
    localStorage.setItem(this.storage_name, JSON.stringify(this.default_cols));
    global_store.mutations.UPD_CLEAT_LOCALE_STORAGE(true);
    global_store.mutations.UPD_TABLE_KEY(incremented_value);
    global_store.mutations.RERENDER_TABLES();
  }

  clear_or_upd_cols() {
    const stored_cols_JSON = localStorage.getItem(this.storage_name);

    if (stored_cols_JSON !== null) {
      const stored_cols = JSON.parse(stored_cols_JSON) as TableCol[];

      if (this.cols_list_local.length !== stored_cols.length) {
        localStorage.removeItem(this.storage_name);
      } else {
        let clear_storage = false;

        for (let i = 0; i < this.cols_list_local.length; i++) {
          if (this.cols_list_local[i].text !== stored_cols[i].text) {
            clear_storage = true;
            break;
          }
        }

        if (clear_storage) {
          localStorage.removeItem(this.storage_name);
          localStorage.setItem(this.storage_name, JSON.stringify(this.default_cols));
        }
      }
    }
  }
}
</script>
